<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <slot @stopLoading="stopLoading" />
    </div>
    <loading :show="boolLoading" :label="txtLoading" />
  </div>
</template>

<script>
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  data () {
    return {
      errMsg: '',
      boolLoading: false,
      txtLoading: 'Loading...',

      dismissibleType: 'danger',
      showDismissibleAlert: false,
      timeout: 8
    }
  },
  created: function () {
    let self = this

    self.$root.$on('toggleloader', function (val) {
      self.toggleloader(val)
    })

    self.$root.$on('showNotification', function (message, type) {
      self.errMsg = message
      self.dismissibleType = type || 'danger'
      self.showDismissibleAlert = true

      setTimeout(function () {
        self.errMsg = ''
        self.dismissibleType = 'danger'
        self.showDismissibleAlert = false
      }, self.timeout * 1000)
    })
  },
  methods: {
    toggleloader: function (val) {
      let self = this
      self.boolLoading = val
    }
  },
  mounted () {
    let self = this
    self.toggleloader(true)
  }
}</script>



// WEBPACK FOOTER //
// src/components/BasePageComponent.vue